import React, { useMemo, useCallback, useState } from 'react'

const ContactsModal = ({
  showContactsModal,
  setShowContactsModal,
  activeTab,
  handleTabSwitch,
  searchTerm,
  setSearchTerm,
  memberGroups,
  tags,
  isLoadingGroups,
  isLoadingTags,
  selectedGroups,
  setSelectedGroups,
  selectedTags,
  setSelectedTags,
}) => {
  const [searchType, setSearchType] = useState('name') // 'name' 或 'tag'

  // 所有 hooks 都在最頂部
  const filteredMemberGroups = useMemo(() => {
    if (searchType === 'name') {
      // 按名稱搜尋
      return memberGroups.filter((group) =>
        group.name.toLowerCase().includes(searchTerm.toLowerCase())
      )
    } else {
      // 按標籤搜尋
      return memberGroups.filter((group) => {
        if (!group.tags || group.tags.length === 0) return false
        return group.tags.some((tag) =>
          tag.toLowerCase().includes(searchTerm.toLowerCase())
        )
      })
    }
  }, [memberGroups, searchTerm, searchType])

  const isAllSelected = useCallback(() => {
    return (
      filteredMemberGroups.length > 0 &&
      filteredMemberGroups.every((group) =>
        selectedGroups.includes(group.member_group_id)
      )
    )
  }, [filteredMemberGroups, selectedGroups])

  const handleSelectAll = useCallback(() => {
    if (isAllSelected()) {
      const currentGroupIds = filteredMemberGroups.map(
        (group) => group.member_group_id
      )
      setSelectedGroups(
        selectedGroups.filter((id) => !currentGroupIds.includes(id))
      )
    } else {
      const currentGroupIds = filteredMemberGroups.map(
        (group) => group.member_group_id
      )
      const newSelectedGroups = [
        ...new Set([...selectedGroups, ...currentGroupIds]),
      ]
      setSelectedGroups(newSelectedGroups)
    }
  }, [filteredMemberGroups, selectedGroups, setSelectedGroups])

  // 條件返回放在所有 hooks 之後
  if (!showContactsModal) return null

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 10000,
      }}
      onClick={(e) =>
        e.target === e.currentTarget && setShowContactsModal(false)
      }
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          width: '90%',
          maxWidth: '600px',
          maxHeight: '80vh',
          overflow: 'hidden',
          boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
        }}
      >
        {/* Modal Header */}
        <div
          style={{
            padding: '20px',
            borderBottom: '1px solid #e9ecef',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
          }}
        >
          <h4 style={{ margin: 0, color: '#2c3e50' }}>搜尋聯絡人</h4>
          <button
            onClick={() => setShowContactsModal(false)}
            style={{
              position: 'absolute',
              right: '20px',
              background: 'none',
              border: 'none',
              fontSize: '20px',
              cursor: 'pointer',
              color: '#6c757d',
            }}
          >
            ✕
          </button>
        </div>

        {/* 搜尋類型選擇與搜尋框 */}
        <div style={{ padding: '20px', borderBottom: '1px solid #e9ecef' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '15px',
              marginBottom: '15px',
            }}
          >
            <label
              style={{ fontSize: '14px', fontWeight: '500', color: '#495057' }}
            >
              搜尋類型：
            </label>
            <div style={{ display: 'flex', gap: '10px' }}>
              <label
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                }}
              >
                <input
                  type="radio"
                  name="searchType"
                  value="name"
                  checked={searchType === 'name'}
                  onChange={(e) => setSearchType(e.target.value)}
                  style={{ marginRight: '5px' }}
                />
                搜尋名稱
              </label>
              <label
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                }}
              >
                <input
                  type="radio"
                  name="searchType"
                  value="tag"
                  checked={searchType === 'tag'}
                  onChange={(e) => setSearchType(e.target.value)}
                  style={{ marginRight: '5px' }}
                />
                搜尋標籤
              </label>
            </div>
          </div>

          <input
            type="text"
            className="form-control"
            placeholder={
              searchType === 'name' ? '請搜尋聯絡人名稱' : '請搜尋標籤'
            }
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              width: '100%',
              padding: '10px 12px',
              border: '1px solid #ddd',
              borderRadius: '6px',
              fontSize: '14px',
            }}
            autoComplete="off"
            spellCheck="false"
          />
        </div>

        {/* Modal Body */}
        <div style={{ padding: '20px', height: '400px', overflow: 'auto' }}>
          {/* 全選列 */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '10px 0',
              borderBottom: '2px solid #e9ecef',
              fontWeight: '600',
              color: '#495057',
              backgroundColor: '#f8f9fa',
            }}
          >
            <input
              type="checkbox"
              checked={isAllSelected()}
              onChange={handleSelectAll}
              disabled={filteredMemberGroups.length === 0}
              style={{
                marginRight: '12px',
                cursor:
                  filteredMemberGroups.length === 0 ? 'not-allowed' : 'pointer',
              }}
            />
            <div style={{ flex: 1 }}>
              {isAllSelected() ? '取消全選' : '全選'}
            </div>
          </div>

          {/* 聯絡人列表 */}
          {filteredMemberGroups.map((group) => (
            <div
              key={group.member_group_id}
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                padding: '12px 0',
                borderBottom: '1px solid #f1f3f4',
                cursor: 'pointer',
              }}
              onClick={() => {
                if (selectedGroups.includes(group.member_group_id)) {
                  setSelectedGroups(
                    selectedGroups.filter((id) => id !== group.member_group_id)
                  )
                } else {
                  setSelectedGroups([...selectedGroups, group.member_group_id])
                }
              }}
            >
              <input
                type="checkbox"
                checked={selectedGroups.includes(group.member_group_id)}
                onChange={() => {}}
                style={{ marginRight: '12px', marginTop: '2px' }}
              />
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    fontSize: '14px',
                    fontWeight: '500',
                    color: '#2c3e50',
                    marginBottom: '4px',
                  }}
                >
                  {group.name}
                </div>
                {/* 在群組資訊中顯示標籤 */}
                <div
                  style={{
                    fontSize: '12px',
                    color: '#6c757d',
                    marginBottom: '4px',
                  }}
                >
                  {group.description}
                </div>
                {group.tags && group.tags.length > 0 && (
                  <div
                    style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}
                  >
                    {group.tags.map((tag, index) => (
                      <span
                        key={index}
                        style={{
                          backgroundColor: '#e3f2fd',
                          color: '#1976d2',
                          fontSize: '11px',
                          padding: '2px 6px',
                          borderRadius: '10px',
                          border: '1px solid #bbdefb',
                        }}
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}

          {/* 無搜尋結果 */}
          {filteredMemberGroups.length === 0 && (
            <div
              style={{
                textAlign: 'center',
                padding: '40px 20px',
                color: '#6c757d',
                fontSize: '14px',
              }}
            >
              {searchType === 'name'
                ? '沒有找到符合的聯絡人'
                : '沒有找到符合的標籤'}
            </div>
          )}
        </div>

        {/* Modal Footer */}
        <div
          style={{
            padding: '20px',
            borderTop: '1px solid #e9ecef',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <div style={{ fontSize: '14px', color: '#6c757d' }}>
            已選擇： {selectedGroups.length} 個聯絡人群組
          </div>
          <div>
            <button
              onClick={() => setShowContactsModal(false)}
              style={{
                padding: '8px 16px',
                marginRight: '10px',
                backgroundColor: '#6c757d',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
              }}
            >
              取消
            </button>
            <button
              onClick={() => {
                setShowContactsModal(false)
              }}
              style={{
                padding: '8px 16px',
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
              }}
            >
              確認
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default React.memo(ContactsModal)
